import React, { useState, useEffect } from 'react';
import { array, bool, func, object, string } from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import { get, isEmpty, isNil } from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import clsx from 'clsx';

import Button from '@material-ui/core/Button';
import BobConfirmButton from './../../../components/BobConfirmButton';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import { ChromePicker } from 'react-color';

import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import FileUploadInput from '../../../containers/Global/FileUploadInput';
import GoogleLogo from '../../../components/GoogleLogo';
import { TimezoneOffsets } from '../../../helpers/timezones';
import cognitoData from '../../../awsConfig';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as CompanyManagementActions from '../../../actions/companyManagementActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityPage.module.css';
import { ClickAwayListener } from '@material-ui/core';

const ValidationSchema = Yup.object().shape({
    name: Yup.string()
        .max(100)
        .required(),
    contractorName: Yup.array()
        .required(),
    accentColor: Yup.string()
        .nullable()
        .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Must be formatted as a hex value: #000000'),
    addressSearch: Yup.string()
        .required(),
    timeZone: Yup.object()
        .required()
});

const CompanyDetails = ({
    activeNavCompany,
    close,
    clearErrors,
    contractorTypes,
    currentUser,
    open,
    history,
    title,
    isLoading,
    errors,
    onClose,
    toggleLoading,
    setSelectedCompany,
    ...props
}) => {
    const [address, setAddress] = useState({});

    const [address1, setAddress1] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState('');
    const [fileImport, setFileImport] = useState(null);
    const [hasCompanyLogo, setHasCompanyLogo] = useState(false);
    const [logoPath, setLogoPath] = useState(null);

    const [showColorPicker, setShowColorPicker] = useState(false);

    const formik = useFormik({
        initialValues: {
            id:             get(props, 'selectedCompany.id', ''),
            accentColor:    get(props, 'selectedCompany.accentColor', ''),
            addressSearch:  get(props, 'selectedCompany.address.formattedAddress', ''),
            contractorName: get(props, 'selectedCompany.contractorTypeIds', []),
            name:           get(props, 'selectedCompany.name', ''),
            timeZone:       {
                name:   get(props, 'selectedCompany.timeZone', ''),
                offset: get(props, 'selectedCompany.timeZoneOffset', '')
            }
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                createCompany,
                updateCompany
            } = props;

            let scoringEnabled = props.selectedCompany ? props.selectedCompany.scoringEnabled : false;
            let isCreated;

            const body = {
                name:              values.name,
                address,
                contractorTypeIds: values.contractorName,
                accentColor:       values.accentColor,
                fileImport,
                timeZone:          values.timeZone.name,
                timeZoneOffset:    values.timeZone.offSet,
                scoringEnabled
            };

            if (fileImport || (props.selectedCompany && props.selectedCompany.hasLogo)) body.hasLogo = true;

            clearErrors();
            setSubmitting(true);

            try {
                if (!isLoading) {
                    toggleLoading(true);
                    if (isNil(props.selectedCompany)) {
                        isCreated = await createCompany(body);
                    }
                    else {
                        isCreated = await updateCompany(props.selectedCompany.id, body);
                    }
                }

                if (isCreated) {
                    const { companies } = props;

                    if (companies.length === 1) {
                        //window.location.reload();
                    }
                    else {
                        handleClose();
                    }
                    setSubmitting(false);
                    toggleLoading(false);
                } else {
                    setSubmitting(false);
                    toggleLoading(false);
                }
                setSelectedCompany({ ...props.selectedCompany, ...body });
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    useEffect(() => {
        if (props.selectedCompany) {
            setHasCompanyLogo(props.selectedCompany.hasLogo);
            if (props.selectedCompany.hasLogo) {
                setLogoPath(`${cognitoData.key2act.applications.companyLogo.url}${props.companyInfo.companyId}/logo.png`);
            }
        }
        else {
            setHasCompanyLogo(false);
        }
    }, [props.companyCreate, props.selectedCompany]);

    const handleGeocodeAddress = async address => {
        try {
            const results = await geocodeByAddress(address);
            const latLng = await getLatLng(results[0]);

            const streetNumber = results[0].address_components.find(result => {
                return result.types.includes('street_number');
            });

            const route = results[0].address_components.find(result => {
                return result.types.includes('route');
            });

            const city = results[0].address_components.find(result => {
                return result.types.includes('locality');
            });

            const administrativeAreaLevel2 = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_2');
            });

            const administrativeAreaLevel3 = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_3');
            });

            const state = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_1');
            });

            const zip = results[0].address_components.find(result => {
                return result.types.includes('postal_code');
            });

            const addrcountry = results[0].address_components.find(result => {
                return result.types.includes('country');
            });

            const address1Check = streetNumber ? `${streetNumber.long_name} ${route.long_name}` : route.long_name;
            const cityCheck = city ? city.long_name : administrativeAreaLevel3.long_name;

            formik.setFieldValue('addressSearch', results[0].formatted_address);

            setAddress1(address1Check);
            setCity(cityCheck);
            setState(state.short_name);
            setZip(zip.long_name);
            setCountry(addrcountry.long_name);

            setAddress({
                latitude:                 get(latLng, 'lat', ''),
                longitude:                get(latLng, 'lng', ''),
                administrativeAreaLevel1: get(state, 'short_name', ''),
                administrativeAreaLevel2: get(administrativeAreaLevel2, 'long_name', ''),
                country:                  get(addrcountry, 'short_name', ''),
                locality:                 cityCheck,
                postalCode:               get(zip, 'long_name', ''),
                route:                    get(route, 'long_name', ''),
                streetNumber:             streetNumber ? streetNumber.long_name : '',
                formattedAddress:         get(results[0], 'formatted_address', '')
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error: ', error);
        }
    };

    const handleImport = ({ file, fileName }) => {
        setFileImport(file);
        setLogoPath(file);
    };

    const handleImportClear = () => {
        setFileImport(null);
        setLogoPath('');
    };

    const handleClose = () => {
        toggleLoading(false);
        clearErrors();
        onClose();

        setTimeout(() => {
            // need timeout to allow the setSelectedCompany to update
            setSelectedCompany(null);

            if (currentUser.isSuperUser) {
                if (history.location.state.returnUrl) {
                    let state = {...history.location.state};
                    delete state.isManage;
                    history.replace({...history.location, state});
                }
                else {
                    history.push(`/v2/dashboard/company?appId=ad356bf2-b9db-4bb5-922e-c3394b1a63e3&childId=ccb00d85-7b0c-44ba-bd0e-db216ef1ee46&company=${ activeNavCompany.id }&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4`);
                }
            }
            else if (history.location.state && history.location.state.returnUrl) {
                history.push(history.location.state.returnUrl);
            }
            else {
                history.push(`/v2/dashboard/company?appId=ad356bf2-b9db-4bb5-922e-c3394b1a63e3&childId=ccb00d85-7b0c-44ba-bd0e-db216ef1ee46&company=${ activeNavCompany.id }&parentId=ad356bf2-b9db-4bb5-922e-c3394b1a63e4`);
            }
        }, 100);
    };

    const handleCancel = () => {
        handleReset();
        handleClose();
    };

    const handleTimeZoneChange = (event, timezone) => {
        formik.setFieldValue('timeZone', timezone);
    };

    const handleColorChange = color => {
        formik.setFieldValue('accentColor', color.hex);
        formik.setFieldTouched('accentColor');
    };

    const handleReset = () => {
        setAddress1('');
        setCity('');
        setState('');
        setZip('');
        setFileImport(null);    

        formik.handleReset();
    };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 400
            },
        },
    };

    const renderContractorTypes = (selected) => {
        let displayValue = '';

        selected.forEach((id) => {
            const type = contractorTypes.find(c => c.id === id);
            if (type) {
                displayValue += type.name + ',';
            }
        });

        return displayValue.substring(0, displayValue.length - 1);
    };

    if (!isEmpty(formik.values.addressSearch) && isEmpty(address1)) {
        handleGeocodeAddress(formik.values.addressSearch);
    }

    return (
        <div className={classes.companyForm}>
            <div className={classes.companyDetailsHeaderRow}>
                Company Details
            </div>
            <div className={classes.companySettingsHeaderRow}>
                Company Settings
            </div>
            <div className={classes.companyDetailsPanel}>
                <div className={classes.inputs}>
                    <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                        <TextField
                            id="name"
                            name="name"
                            type="text"
                            variant="outlined"
                            size="small"
                            value={formik.values.name}
                            label="Company Name"
                            onChange={formik.handleChange}
                            InputLabelProps={{
                                classes: {
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }
                            }}
                            InputProps={{
                                onBlur:  formik.handleBlur,
                                classes: {
                                    error: classes.cssErrorUnderline,
                                    root:  classes.input
                                }
                            }}
                            FormHelperTextProps={{
                                classes: {
                                    error: classes.error
                                }
                            }}
                            error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                            helperText={Boolean(formik.touched.name) && formik.errors.name}
                        />
                    </FormControl>
                    <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                        <InputLabel
                            htmlFor="outlined-contractor-native-simple"
                            classes={{
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }}
                            style={{
                                backgroundColor: 'white',
                                paddingRight:    '5px'
                            }}
                            error={Boolean(formik.errors.contractorName) && Boolean(formik.touched.contractorName)}
                        >
                            Contractor Type
                        </InputLabel>
                        <Select
                            MenuProps={MenuProps}
                            multiple
                            classes={{
                                outlined: classes.outlined
                            }}
                            value={formik.values.contractorName}
                            id="contractorName"
                            label="contractor types"
                            renderValue={renderContractorTypes}
                            onChange={formik.handleChange}
                            name="contractorName"
                            inputProps={{
                                name:   'contractorName',
                                id:     'outlined-contractor-native-simple',
                                onBlur: formik.handleBlur
                            }}
                            error={Boolean(formik.errors.contractorName) && Boolean(formik.touched.contractorName)}
                        >
                            <MenuItem value="none" disabled>
                                Select Contractor Types
                            </MenuItem>
                            {contractorTypes.map(contractorType => (
                                <MenuItem
                                    className={classes.selectMenuItem}
                                    value={contractorType.id}
                                    key={contractorType.id}
                                >
                                    <Checkbox
                                        style={{color: 'black'}}
                                        checked={formik.values.contractorName.indexOf(contractorType.id) > -1}
                                    />
                                    <ListItemText primary={contractorType.name} />
                                </MenuItem>
                            ))}
                        </Select>
                        {formik.touched.contractorName &&
                             formik.errors.contractorName && <FormHelperText className={classes.error}>{formik.errors.contractorName}</FormHelperText>}
                    </FormControl>
                    <FormControl className={classes.inputWrapper}>
                        <AutoComplete
                            id="combo-box-timezones"
                            options={TimezoneOffsets}
                            getOptionLabel={(option) => option.name || ''}
                            value={formik.values.timeZone}
                            getOptionSelected={(option, value) => option.name === value.name}
                            onChange={handleTimeZoneChange}
                            size="small"
                            required
                            renderInput={(params) => 
                                <TextField 
                                    {...params} 
                                    label="Time Zone" 
                                    variant="outlined" 
                                    error={Boolean(formik.errors.timeZone) && Boolean(formik.touched.timeZone)}
                                />}
                        />
                    </FormControl>
                    <PlacesAutocomplete
                        value={formik.values.addressSearch}
                        onChange={address => formik.setFieldValue('addressSearch', address)}
                        onSelect={(handleGeocodeAddress)}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                            <React.Fragment>
                                <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                                    <TextField
                                        {...getInputProps({
                                            name: 'addressSearch',
                                            id:   'addressSearch'
                                            
                                        })}
                                        InputProps={{
                                            onBlur:  formik.handleBlur,
                                            classes: {
                                                root: classes.input
                                            }
                                        }}
                                        variant="outlined"
                                        size="small"
                                        label="Search for Address"
                                        classes={{
                                            root: classes.input
                                        }}
                                        error={Boolean(formik.errors.addressSearch) && Boolean(formik.touched.addressSearch)}
                                    />
                                    {formik.touched.addressSearch &&
                                        formik.errors.addressSearch && <FormHelperText className={classes.error}>{formik.errors.addressSearch}</FormHelperText>}
                                </FormControl>
                                {suggestions.length > 0 && <Paper className={classes.autoCompleteList}>
                                    <List>
                                        {suggestions.map((suggestion, index) => {
                                            return (
                                                <div key={index}>
                                                    <ListItem
                                                        button
                                                        className={classes.autoCompleteListItem}
                                                        {...getSuggestionItemProps(suggestion)}
                                                    >
                                                        <ListItemText primary={suggestion.description} />
                                                    </ListItem>
                                                </div>
                                            );
                                        })}
                                    </List>
                                    <GoogleLogo />
                                </Paper>}
                            </React.Fragment>
                        )}
                    </PlacesAutocomplete>
                    <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                        <TextField
                            id="address1"
                            name="address1"
                            type="text"
                            variant="outlined"
                            size="small"
                            value={address1}
                            label="Address"
                            disabled
                            InputLabelProps={{
                                classes: {
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }
                            }}
                            InputProps={{
                                classes: {
                                    root: classes.input
                                }
                            }}
                        />
                    </FormControl>
                    <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                        <TextField
                            id="city"
                            name="city"
                            type="text"
                            variant="outlined"
                            size="small"
                            value={city}
                            label="City"
                            disabled
                            InputLabelProps={{
                                classes: {
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }
                            }}
                            InputProps={{
                                classes: {
                                    root: classes.input
                                }
                            }}
                        />
                    </FormControl>
                    <div className={classes.addressFormRow}>
                        <FormControl variant="outlined" size="small" className={clsx(classes.inputWrapper, classes.state)}>
                            <TextField
                                id="state"
                                name="state"
                                type="text"
                                variant="outlined"
                                size="small"
                                value={state}
                                label="State"
                                disabled
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    classes: {
                                        root: classes.input
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl variant="outlined" size="small" className={clsx(classes.inputWrapper, classes.zip)}>
                            <TextField
                                id="zip"
                                name="zip"
                                type="text"
                                variant="outlined"
                                size="small"
                                value={zip}
                                label="Zip Code"
                                disabled
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    classes: {
                                        root: classes.input
                                    }
                                }}
                            />
                        </FormControl>
                    </div>
                    <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                        <TextField
                            id="country"
                            name="country"
                            type="text"
                            variant="outlined"
                            size="small"
                            value={country}
                            label="Country"
                            disabled
                            InputLabelProps={{
                                classes: {
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }
                            }}
                            InputProps={{
                                classes: {
                                    root: classes.input
                                }
                            }}
                        />
                    </FormControl>
                    <FormControl variant="outlined" size="small" className={classes.fileUploadWrapper}>
                        <InputLabel
                            htmlFor=""
                            classes={{
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }}
                            error={Boolean(formik.errors.contractorName) && Boolean(formik.touched.contractorName)}
                        />
                        <FileUploadInput
                            accept=".png"
                            initialText="Company Logo"
                            upload={handleImport}
                            clear={handleImportClear}
                        />
                    </FormControl>
                    { hasCompanyLogo ? 
                        <div className={classes.companyLogo}>
                            <img 
                                src={logoPath}
                                alt="company logo" 
                                height="5rem" 
                                crossOrigin="anonymous"
                            />
                        </div>
                        : null 
                    }
                    <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                        <TextField
                            id="accentColor"
                            name="accentColor"
                            type="text"
                            variant="outlined"
                            size="small"
                            value={formik.values.accentColor || ''}
                            label="Accent Color"
                            onChange={formik.handleChange}
                            onClick={() => setShowColorPicker(!showColorPicker)}
                            InputLabelProps={{
                                classes: {
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }
                            }}
                            InputProps={{
                                onBlur:  formik.handleBlur,
                                classes: {
                                    root: classes.input
                                }
                            }}
                            FormHelperTextProps={{
                                classes: {
                                    error: classes.error
                                }
                            }}
                            error={Boolean(formik.errors.accentColor) && Boolean(formik.touched.accentColor)}
                            helperText={Boolean(formik.touched.accentColor) && formik.errors.accentColor}
                        />
                    </FormControl>
                    {showColorPicker ? 
                        <ClickAwayListener onClickAway={() => setShowColorPicker(!showColorPicker)}>
                            <ChromePicker
                                color={formik.values.accentColor || ''}
                                onChangeComplete={handleColorChange}
                            />
                        </ClickAwayListener>
                        : null
                    }
                </div>
            </div>
            <div className={classes.companySettingsPanel}>
                Settings
            </div>
            <div className={classes.companyButtonsPanel}>
                <Button
                    className={classes.Button}
                    onClick={handleCancel}
                    variant="contained"
                >
                    Cancel
                </Button>
                <BobConfirmButton
                    className={classes.ButtonWithMargin}
                    isLoading={isLoading}
                    disabled={formik.isSubmitting || isLoading}
                    label={props.selectedCompany ? 'Update' : 'Create'}
                    onClick={formik.handleSubmit}
                />
            </div>
        </div>
    );
};

CompanyDetails.defaultProps = {
    close:           () => {},
    companyInfo:     {},
    companies:       [],
    contractorTypes: [],
    errors:          [],
    isLoading:       false,
    title:           ''
};

CompanyDetails.propTypes = {
    close:           func,
    companyInfo:     object,
    companies:       array,
    contractorTypes: array,
    errors:          array,
    isLoading:       bool,
    title:           string
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        companyInfo:      state.companyInfo,
        companies:        state.core.companies,
        contractorTypes:  state.companyInfo.contractorTypes,
        currentUser:      state.currentUser,
        errors:           state.messages.errors,
        isLoading:        state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...CompanyManagementActions,
    ...UiActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyDetails));
